import React, { useCallback, useState } from 'react';
import { Form, Header, Button } from 'semantic-ui-react';
import CreditorSubForm from './CreditorSubForm';
import VehicleDisplay from '../vehicle/VehicleDisplay';
import styles from './CreditorForm.module.scss';
import Fields from './CreditorFields';
import { useErrors, useIsValid, useForm } from '../PolicyForm';

const CreditorForm = ({ data, onChange, vehicle, onContinue, onSaveAndExit, onCancel, isEdit, addressLookup, addressState }) => {
	const [showErrors, setShowErrors] = useState(false);
	const errors = useErrors(data, Fields);
	const isValid = useIsValid(errors);
	const form = useForm(Fields, data, errors, showErrors, onChange);

	const _onContinue = useCallback(() => {
		if (isValid) {
			onContinue();
		} else {
			setShowErrors(true);
		}
	}, [isValid, onContinue]);

	return (
		<React.Fragment>
			<Header>Please tell us about the creditor you're {isEdit ? 'editing:' : 'adding to the vehicle:'}</Header>
			<Form>
				<div>
					<VehicleDisplay vehicle={vehicle} />
				</div>
				<CreditorSubForm form={form} isEdit={isEdit} addressLookup={addressLookup} addressState={addressState} />
				<div className={styles.buttons}>
					<Button id="continueBtn" primary onClick={_onContinue}>
						Continue
					</Button>
					<Button id="saveAndExitBtn" primary onClick={onSaveAndExit}>
						Save and Exit
					</Button>
					<Button id="cancelBtn" primary onClick={onCancel}>
						Cancel
					</Button>
				</div>
			</Form>
		</React.Fragment>
	);
};

export default CreditorForm;
